(function () {
    'use strict';

    angular
        .module('showcaseApp')
        .component('pagarmeConnectOptions', {
            templateUrl: 'app/admin/settings/payments/components/pagarme-connect-options/pagarme-connect-options.html',
            bindings: {
                onAuthorize: '&',
                onConnectAsRecipient: '&'
            },
            controller: pagarmeConnectOptionsController
        });

    function pagarmeConnectOptionsController() {
        var $ctrl = this;

        $ctrl.authorize = function () {
            $ctrl.onAuthorize();
        };

        $ctrl.connectAsRecipient = function () {
            $ctrl.onConnectAsRecipient();
        };
    }
})();
